import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatDividerModule} from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs'
import { MatGridListModule } from '@angular/material/grid-list'
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { ErrorStateMatcher, MatNativeDateModule, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import {MatTreeModule} from '@angular/material/tree'
import {MatSnackBarModule} from '@angular/material/snack-bar'
import {MatProgressBarModule} from '@angular/material/progress-bar'
import {MatCardModule} from '@angular/material/card'
import {MatChipsModule} from '@angular/material/chips'
import {MatCheckboxModule} from '@angular/material/checkbox'
import {MatRadioModule} from '@angular/material/radio'
import {ReactiveFormsModule} from '@angular/forms'
import {MatAutocompleteModule} from '@angular/material/autocomplete'
import {MatSlideToggleModule} from '@angular/material/slide-toggle'
import {MatButtonToggleModule} from '@angular/material/button-toggle'
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSliderModule } from '@angular/material/slider';
import {MatBadgeModule} from '@angular/material/badge';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SpinnerComponent } from './spinner.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
    providers: [
        {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: false}},
        {provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher},
        {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline'}},
        {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {floatLabel: 'always'}}
      ],
    declarations: [SpinnerComponent],
    imports: [
        CommonModule,
        MatAutocompleteModule,
        MatCardModule,
        MatTabsModule,
        MatToolbarModule,
        MatSidenavModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatDividerModule,
        MatTableModule,
        MatListModule,
        MatExpansionModule,
        MatTooltipModule,
        MatGridListModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatPaginatorModule,
        MatSortModule,
        MatTreeModule,
        MatProgressBarModule,
        MatSnackBarModule,
        MatChipsModule,
        MatRadioModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        MatSliderModule,
        MatBadgeModule,
        MatBottomSheetModule,
        OverlayModule
      ],
    exports: [
        CommonModule,
        MatAutocompleteModule,
        MatCardModule,
        MatTabsModule,
        MatToolbarModule,
        MatSidenavModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatDividerModule,
        MatTableModule,
        MatListModule,
        MatExpansionModule,
        MatTooltipModule,
        MatGridListModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        SpinnerComponent,
        MatSelectModule,
        MatPaginatorModule,
        MatSortModule,
        MatTreeModule,
        MatProgressBarModule,
        MatSnackBarModule,
        MatChipsModule,
        MatRadioModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        MatSliderModule,
        MatBadgeModule,
        OverlayModule
    ]
})
export class MaterialModule { }
